import { Calendar, Search, Repeat } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import type { TranslationKey } from "@/i18n/translations";

const steps: {
  number: string;
  icon: typeof Calendar;
  titleKey: TranslationKey;
  bodyKey: TranslationKey;
}[] = [
  { number: "1", icon: Calendar, titleKey: "how.step1.title", bodyKey: "how.step1.body" },
  { number: "2", icon: Search, titleKey: "how.step2.title", bodyKey: "how.step2.body" },
  { number: "3", icon: Repeat, titleKey: "how.step3.title", bodyKey: "how.step3.body" },
];

const HowItWorksSection = () => {
  const { t } = useLanguage();

  return (
    <section id="how-it-works" className="py-24 bg-secondary/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16 space-y-4">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter">
              {t("how.title")}
            </h2>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step) => (
              <div
                key={step.number}
                className="relative text-center p-8 bg-background rounded-sm border border-border/50 hover:shadow-lg transition-shadow"
              >
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 h-8 w-8 rounded-full bg-accent text-accent-foreground flex items-center justify-center font-bold text-sm">
                  {step.number}
                </div>
                <div className="h-14 w-14 rounded-sm bg-accent/10 flex items-center justify-center mx-auto mb-6 mt-4">
                  <step.icon className="h-7 w-7 text-accent" />
                </div>
                <h3 className="text-xl font-bold mb-3">{t(step.titleKey)}</h3>
                <p className="text-muted-foreground font-serif">{t(step.bodyKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
